// @flow
import { paragraphFontFamilies } from './general';
import type { ObjectType } from '@types/misc';

export const sliderInput = {
  fontSize: '14px !important',
  fontFamily: paragraphFontFamilies,
  padding: '5px !important',
  borderRadius: '5px !important',
  border: '1px solid #e6e6e6 !important',
  boxShadow: 'none !important',
  lineHeight: '1.15 !important',
  marginBottom: '0 !important',
  height: '28px !important',
  background: 'white',
  $nest: {
    '&:focus': {
      background: 'white !important'
    }
  }
}
